import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class DesignationLevel extends EntityDto implements IEntityDto {
    Designation_Level_Id: string;
    DesignationLevelName: string;
    Description: string;
    OrderNo: number;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Designation_Level_Id = "00000000-0000-0000-0000-000000000000";
        this.DesignationLevelName = "";
        this.Description = "";
        this.TotalCount = 0;
        this.OrderNo = 0;
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'DesignationLevelName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Level Name is required' },
            { FieldName: 'OrderNo', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Order No. is required' },

        ];
    }
}
